import React, { useContext, useMemo } from 'react';
import clsx from 'clsx';

import { Styled } from './index.styles';
import { serverData } from '../HotelOverview';
import { usePageContext } from '../../../context/PageContext';
import { overviewMockData } from '../mockdata/overview';
import { useCheckBreakpoint } from '../../../hooks';
import { useHQVContext } from '../../../context/HQVContext';
import { useSearchResultsStore } from '../../../modules/store/searchResultsStore';

const Overview: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent }: any = useContext(serverData);
  const { hqvState } = useHQVContext();
  const { pageState, isDTT, isAuthorMode } = usePageContext();
  const isViewportL = useCheckBreakpoint('viewportL');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const overviewData = useSearchResultsStore((state: { propertyInfoData: any }) => state.propertyInfoData);

  const propertyOverviewData = useMemo(() => {
    return pageState?.authorMode || isAuthorMode ? overviewMockData.textContentData : overviewData?.propertyInfoData;
  }, [pageState, overviewData]);

  let selectedDescription = '';
  propertyOverviewData?.property?.basicInformation?.descriptions.forEach(
    (description: { type: { code: string }; text: string; localizedText: { translatedText: string } }) => {
      if (description?.type?.code === 'location') {
        selectedDescription = isDTT ? description?.text : description?.localizedText?.translatedText;
      }
    }
  );

  return (
    <Styled>
      {selectedDescription && (
        <div
          className={clsx(
            'px-3',
            'color-scheme1',
            'hotel-overview-container',
            `${hqvState?.modalOpenState ? 'hqv-modal' : ''}`
          )}
        >
          <div className="overview-title-container">
            {jsonContent && (
              <h2 className={clsx(isViewportL ? 't-title-s' : 't-subtitle-xl', 'overview-title')}>
                {jsonContent.overviewLabel}
              </h2>
            )}
            <p className={clsx(isViewportL ? 't-font-m' : 't-font-s', 'overview-description')}>{selectedDescription}</p>
          </div>
        </div>
      )}
    </Styled>
  );
};

export default Overview;
